import React, { ReactNode } from 'react';
import clsx from 'clsx';
import style from './Style.module.css';

export interface props {
  children: ReactNode;
  className?: string;
}

const Box = ({ children, className }: props) => {
  return (
    <div className={clsx('border-card', className, style['box'])}>
      {children}
    </div>
  );
};

export default Box;
